<ng-template #nameHeader>
  <div style="text-align: left">
    <span>{{ nameColumnName }}</span>
  </div>
</ng-template>
<ng-template #relatedWorksHeader>
  <span>{{ relatedWorksColumnName }}</span>
</ng-template>
<ng-template #relatedNetworksHeader>
  <span>{{ relatedNetworksColumnName }}</span>
</ng-template>

<ng-template #logoCell let-person
  ><img alt="Person Logo" [src]="person?.logoPath"
/></ng-template>
<ng-template #personCell let-person>
  <a
    [routerLink]="person | personUrl"
    queryParamsHandling="merge"
    data-qa="search-result-link"
    ><span>{{ person | personName: true }}</span>
    <div>{{ person?.primaryUnitAffiliation?.name }}</div>
  </a>
</ng-template>
<ng-template #relatedWorksCell let-person
  ><span
    (click)="showRelevancyDialog(person, RelevancyProfileView.Works)"
    (keyup.enter)="showRelevancyDialog(person, RelevancyProfileView.Works)"
    tabindex="0"
    >{{ person?.relevantWorksCount }}</span
  ></ng-template
>
<ng-template #relatedNetworksCell let-person
  ><span
    (click)="showRelevancyDialog(person, RelevancyProfileView.Collaborations)"
    (keyup.enter)="
      showRelevancyDialog(person, RelevancyProfileView.Collaborations)
    "
    tabindex="0"
    >View</span
  ></ng-template
>

@if (_people) {
  <aa-grid
    data-qa="search-results-grid"
    rowDataQaTag="search-result-row"
    [rowDefinition]="rowDefinition"
    [columnHeaderDefinitions]="columnHeaderDefinitions"
    [records]="_people"
  >
  </aa-grid>
}
